export const MAX_API_CALL_RETRIES = 3
export const API_CALL_DELAY = () => 2000

export enum TripStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
}
